import { useState, type FormEvent } from "react";
import { APP_COPY, APP_TARGET } from "../config";
import { useAuth } from "../auth";

export function LoginScreen() {
  const { login } = useAuth();
  const [email, setEmail] = useState(APP_COPY.email);
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [showPrivacy, setShowPrivacy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email.trim(), password);
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : "登录失败，请稍后再试");
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className={`login-screen ${APP_TARGET}`}>
      <div className="login-glow glow-a" />
      <div className="login-glow glow-b" />
      <section className="login-card">
        <div className="login-illustration" aria-hidden="true">
          <span className="big-avatar">{APP_COPY.avatar}</span>
          <span className="orbit-heart">♥</span>
          <span className="orbit-star">✦</span>
        </div>
        <p className="eyebrow">{APP_COPY.eyebrow}</p>
        <h1>{APP_COPY.title}</h1>
        <p className="login-subtitle">{APP_COPY.subtitle}</p>
        <form onSubmit={submit}>
          <label>
            <span>专属账号</span>
            <input
              type="text"
              autoComplete="username"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
            />
          </label>
          <label>
            <span>密码</span>
            <input
              type="password"
              autoComplete="current-password"
              placeholder="输入密码"
              minLength={4}
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
            />
          </label>
          {error && <div className="form-error" role="alert">{error}</div>}
          <button className="login-button" type="submit" disabled={busy}>
            {busy ? "正在进入…" : APP_TARGET === "customer" ? "看看今天吃什么 💌" : "进入我的厨房 🍳"}
          </button>
        </form>
        <button type="button" className="privacy-link" onClick={() => setShowPrivacy(true)}>隐私与数据说明</button>
      </section>
      {showPrivacy && (
        <div className="legal-backdrop" role="dialog" aria-modal="true" aria-labelledby="privacy-title">
          <section className="legal-sheet">
            <header><h2 id="privacy-title">隐私与数据说明</h2><button type="button" onClick={() => setShowPrivacy(false)} aria-label="关闭">×</button></header>
            <p>这是仅供我们两个人使用的私人点菜 App，不展示广告，也不会出售个人数据。</p>
            <p>为了登录、菜单、订单和提醒功能，服务会保存登录账号、菜品图片、订单内容、设备推送令牌以及必要的安全日志。</p>
            <p>通信使用 HTTPS，密码以不可逆哈希保存，登录凭证存放在 iOS Keychain 或 Android Keystore。你可以随时联系管理员导出或删除数据。</p>
            <button type="button" className="legal-close" onClick={() => setShowPrivacy(false)}>知道了</button>
          </section>
        </div>
      )}
    </main>
  );
}
